import { nodeListToArray } from './nodelist-to-array'

export default function setUpSubsHiddenToggle(containerClassName: string) {
    const subsContainers = document.getElementsByClassName(containerClassName);

    if (subsContainers.length > 0) {
        const subsContainer = subsContainers[0];

        const triggers = nodeListToArray<HTMLElement>(subsContainer.getElementsByClassName("toggle-hidden-js"));

        triggers.forEach(el => {
            el.addEventListener("click", () => {
                const fields = nodeListToArray<HTMLElement>(subsContainer.getElementsByClassName("toggle-hidden-element-js"));

                fields.forEach(field => {
                    if (field.classList.contains("hidden")) {
                        field.classList.remove("hidden");
                    } else {
                        field.classList.add("hidden");
                    }
                });
            });
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/subs-toggle-hidden.ts